import React, { Component, Fragment, useRef, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import ReactPaginate from 'react-paginate';
import swal from 'sweetalert';
import { deleteStaff, fetchStaffs, setWageFundPaging } from '../../../action/wageFund';
import ErrorContainer from '../../utils/ErrorContainer';
import Loader from '../../utils/Loader';
import Portlet from '../../utils/Portlet';
import Select from 'react-select';
import { fetchFilials } from '../../../action/handbook';
import { isEmpty } from 'lodash';
import { postsIds } from '../../../constants/app';
import Input from '../../utils/Input';
import TableStaff from './TableStaff';
import { useOnClickOutside } from '../../../hooks';

const styles = {
    loading: {
        minHeight: '500px',
        display: 'flex',
        justifyContent: 'center'
    }
}

const ModalDelete = ({ id, name, onClose}) => {
    const [withAfterData, setWithAfterData] = useState(false);
    const loading = useSelector(state => state.loaders.staff);
    
    const ref = useRef();
    const dispatch = useDispatch();

    const onSubmit = () => {
        swal({
            title: "Удаление сотрудника",
            text: `Вы действительно хотите удалить сотрудника${name || id} ${withAfterData ? ' и данные о нем?' : '?'}`,
            icon: "warning",
            dangerMode: true,
            buttons: ["Отмена", "Удалить"],
        }).then((willDelete) => {
            if (willDelete) dispatch(deleteStaff(id, withAfterData));
        });
        
    }
    
    useOnClickOutside(ref, onClose);

    if (loading) return (
        <div>
            <div className="modal fade show" style={{ display: 'block' }}>
                <div className="modal-dialog modal-lg modal-dialog-scrollable" style={{ height: '90%', alignItems: 'center', justifyContent: 'center' }}>
                    <div className="modal-content" style={{ maxWidth: '500px' }}>
                        <div className="modal-body" style={{ minHeight: '150px' }}>
                        <div style={{...styles.tableLoading, marginTop: 100}}>
                            <div className="loader">
                                <div className="kt-spinner kt-spinner--lg kt-spinner--info">
                                </div>
                            </div>
                        </div>
                            <div style={{ color: 'black', fontSize: '1.3rem' }}>{'Загрузка данных'}</div>          
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show" />
        </div>
    )

    return(
        <div>
            <div className="modal fade show" style={{ display: 'block' }}>
                <div className="modal-dialog modal-lg modal-dialog-scrollable" style={{ height: '90%', alignItems: 'center', justifyContent: 'center' }}>
                    <div ref={ref} className="modal-content" style={{ maxWidth: '500px' }}>
                        <div className="modal-header">
                          <div>
                            <h5 className="modal-title"> Удаление сотрудника {name || id} </h5>
                          </div>
                            <button disabled={loading} onClick={onClose} type="button" className="close"></button>
                        </div>
                        <div className="modal-body" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
                                <input type="checkbox" disabled={loading} checked={withAfterData}  onChange={() => setWithAfterData(!withAfterData)} />
                                <span style={{ color: '#000', textAlign: 'center' }}>Удалить данные о сотруднике в разделе "Табель" в последующих за текущим месяцах</span>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button disabled={loading} type="button" className="btn btn-danger" onClick={onSubmit} >Удалить</button>
                            <button disabled={loading} type="button" className="btn btn-secondary" onClick={onClose}>Отмена</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show" />
        </div>
    )
}

class StaffList extends Component {
    state = {
        currentPage: 0,
        filters: {
            pointId: null,
            name_contains: null,
            postId: null,
        },
        openModal: false,
        deleteId: null,
        deleteName: null,
    }

    renderAdress(item) {
        return `${item.city.name ? item.city.name : '---'}, ${item.street}, ${item.house}`;
    };

    onSearch() {
        this.props.fetchStaffs(this.state.filters);
    }

    componentDidMount() {
        this.props.fetchFilials();
        this.onSearch()
    }

    setFilters(field, value) {
        const data = { ...this.state.filters }
        data[field] = value;
        this.setState({ ...this.state, filters: data });
    }

    setPageLimit = (e) => {
        e.preventDefault();
        const updatedPaging = { start: 0, limit: e.target.value};
        this.setState({ currentPage: 0 });
        this.props.setWageFundPaging('staff', updatedPaging);
        this.props.fetchStaffs(this.state.filters);
    }

    handlePageClick = data => {
        const { paging } = this.props;
        this.setState({ currentPage: data.selected }, () => {
            let nextStart =  data.selected * paging.limit;
            const updatedPaging = {...paging, start: nextStart};
            this.props.setWageFundPaging('staff', updatedPaging);
            this.props.fetchStaffs(this.state.filters);
        });
    };

    chekMarginPagesDisplayed = () => {
        const userDisplayWidth = window.innerWidth;

        if(userDisplayWidth < 400) return 1;
        if(userDisplayWidth < 550) return 2;
        if(userDisplayWidth < 850) return 3;
        if(userDisplayWidth < 1250) return 5;
        return 8;
    }

    chekPageRangeDisplayed = () => {
        const userDisplayWidth = window.innerWidth;

        if(userDisplayWidth < 550) return 2;
        if(userDisplayWidth < 850) return 3;
        return 5;
    }

    renderPagination() {
        const { count, paging } = this.props;
        const pages = Math.ceil(+count / +paging.limit);

        return (
            <div className="kt-datatable__pager kt-datatable--paging-loaded">
                <ReactPaginate
                    previousLabel={<i className="flaticon2-back"></i>}
                    nextLabel={<i className="flaticon2-next"></i>}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={pages}
                    marginPagesDisplayed={this.chekMarginPagesDisplayed()}
                    pageRangeDisplayed={this.chekPageRangeDisplayed()}
                    forcePage={this.state.currentPage}
                    onPageChange={this.handlePageClick}
                    containerClassName={'kt-datatable__pager-nav'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                    pageLinkClassName="kt-datatable__pager-link kt-datatable__pager-link-number"
                    previousLinkClassName="kt-datatable__pager-link kt-datatable__pager-link--prev"
                    nextLinkClassName="kt-datatable__pager-link kt-datatable__pager-link--next"
                    activeLinkClassName="kt-datatable__pager-link--active"
                    disabledClassName="kt-datatable__pager-link--disabled"
                />

                    <div className="kt-datatable__pager-info">
                        <div className="kt-datatable__pager-size">
                            <select onChange={this.setPageLimit} value={paging.limit} className="form-control">
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="30">30</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                            
                        </div>
                        {
                            paging.start + paging.limit >= count ? (
                                <span className="kt-datatable__pager-detail">Показано {paging.start + 1} - {+count} из {count}</span>
                            ) : (
                                <span className="kt-datatable__pager-detail">Показано {paging.start + 1} - {+paging.start + +paging.limit} из {count}</span>
                            )
                        }
                       
                    </div>
            </div>
    
        );
    }

    renderSubHeader() {
        return (
            <div className="kt-subheader not-mt kt-grid__item">
                <div className="kt-container  kt-container--fluid">
                    <div className="kt-subheader__main">
                        <h3 className="kt-subheader__title">Сотрудники (табель)</h3>
                    </div>                
                </div>
            </div>
        );
    }

    deleteItem = (item) => {
        this.setState({ openModal: true, deleteId: item.id, deleteName: item.name });
    }

    onCloseDeleteModal = () => {
        this.setState({ openModal: false, deleteId: null, deleteName: null });
    }

    getValuePoint() {
        if (!this.state.filters.pointId || isEmpty(this.props.filials)) return null;
        const entity = this.props.filials.find((point) => point.id === this.state.filters.pointId);
        if (isEmpty(entity)) return null;
        return { value: this.state.filters.pointId, label: this.renderAdress(entity) };
    }

    getValuePost() {
        if (!this.state.filters.postId || isEmpty(postsIds)) return null;
        const entity = postsIds.find((post) => post.id === this.state.filters.postId);
        if (isEmpty(entity)) return null;
        return { value: this.state.filters.postId, label: entity.label };
    }

    render() {
        if (this.props.loading) {
            return (
                <div style={styles.loading}><Loader /></div>
            );
        }
        
        return (
            <Fragment>
                { this.renderSubHeader() }
                <div className="kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid">
                    <div className='kt-portlet__body'>
                        <div className='kt-form kt-form--label-right kt-margin-b-10'>
                            <div className='filterBlocks'>
                            <div style={{ width: 200 }}>
                                <Select
                                    isClearable={true}
                                    closeMenuOnSelect={true}
                                    options={(this.props.filials || []).map((point) => ({ value: point.id, label: this.renderAdress(point) }))}
                                    onChange={(e) => {
                                        if (e && e.value) return this.setFilters('pointId', e.value);
                                        return this.setFilters('pointId', null)
                                    }}
                                    placeholder="Филиал"
                                    noOptionsMessage={() => 'Нет филиалов'}
                                    value={this.getValuePoint()}                   
                                />
                            </div>
                            <div style={{ width: 200 }}>
                                <Select
                                    isClearable={true}
                                    closeMenuOnSelect={true}
                                    options={(postsIds || []).map((post) => ({ value: post.id, label: post.label }))}
                                    onChange={(e) => {
                                        if (e && e.value) return this.setFilters('postId', e.value);
                                        return this.setFilters('postId', null);
                                    }}
                                    placeholder="Должность"
                                    noOptionsMessage={() => 'Нет'}
                                    value={this.getValuePost()}                   
                                />
                            </div>
                            <div style={{ width: 200 }}>
                                <Input
                                    disableGroup={true}
                                    onChange={(e) => {
                                        if (e.target.value !== '') return this.setFilters('name_contains', e.target.value);
                                        return this.setFilters('name_contains', null);
                                    }}
                                    value={this.state.filters.name_contains}
                                    placeholder="ФИО..."
                                />
                            </div>
                            <div>
                                <button className='btn btn-primary' onClick={() => this.onSearch()}>
                                    Найти
                                </button>
                            </div>
                            </div>
                        </div>
                    </div>
                <Portlet fit={true}>
                    <ErrorContainer field="staff" style={{ margin: 15 }} hasCloseButton={true}/>
                    <div className="kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded">
                        <TableStaff filials={this.props.filials} renderAdress={this.renderAdress} deleteItem={this.deleteItem} items={this.props.staff}/>
                        {this.props.staff.length > 0 && this.renderPagination()}
                    </div>
                </Portlet>
            </div>
            {this.state.openModal && <ModalDelete id={this.state.deleteId} name={this.state.deleteName} onClose={this.onCloseDeleteModal} />}
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    staff: state.wageFund.staff,
    loading: state.loaders.staff || state.loaders.filials,
    paging: state.wageFund.paging.staff,
    count: state.wageFund.count.staff,
    user: state.user.info,
    filials: state.handbook.filials,
});

const mapDispatchToProps = {
    fetchStaffs: (params) => fetchStaffs(params, false, false),
    setWageFundPaging: (field, paging) => setWageFundPaging(field, paging),
    deleteStaff: (id) => deleteStaff(id),
    fetchFilials: () => fetchFilials(null, true),
}

export default connect(mapStateToProps, mapDispatchToProps)(StaffList);